import { Component, HostBinding } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'era-fullscreen',
  templateUrl: './fullscreen.component.html',
  imports: [RouterOutlet],
})
export class FullscreenComponent {
  @HostBinding('class') hostClass = 'd-flex h-100 w-100';
}
